import script from "./CompanyProfile.vue?vue&type=script&lang=ts&setup=true"
export * from "./CompanyProfile.vue?vue&type=script&lang=ts&setup=true"

import "./CompanyProfile.vue?vue&type=style&index=0&id=9d6809bc&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9d6809bc"]])

export default __exports__